import { calculateTotal } from '@calculations/price/utilities/total';
import { SnapRoundingOptionsCustom } from '@calculations/round';
import { Decimal } from '@snap-types/types/decimal';
import { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

import { getQuotePriceOrThrow } from '../../utilities/action-guards';

export function onServiceChargeUnitPriceChange(
  state: WritableQuoteBuilderStateType,
  params: {
    quoteLineUuid: string;
    quotePriceUuid: string;
    unitPrice: Decimal;
  },
) {
  const quotePrice = getQuotePriceOrThrow(
    state,
    params.quoteLineUuid,
    params.quotePriceUuid,
  );

  quotePrice.unitPrice = params.unitPrice;
  quotePrice.userUnitPrice = params.unitPrice;
  quotePrice.calculatedUnitPrice = null;

  quotePrice.totalPrice = calculateTotal(
    params.unitPrice,
    quotePrice.quantity,
    SnapRoundingOptionsCustom(state),
  );
}
